import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import EpisodesPage from "@/pages/EpisodesPage";
import EpisodeWorkspace from "@/pages/EpisodeWorkspace";
import LoginPage from "@/pages/LoginPage";
import { AuthProvider, useAuth } from "@/lib/auth";

const Gate = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-amber-400" /></div>;
  if (!user) return <LoginPage />;
  return (
    <Routes>
      <Route path="/" element={<EpisodesPage />} />
      <Route path="/episode/:id" element={<EpisodeWorkspace />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App dark grain">
      <AuthProvider>
        <BrowserRouter>
          <Gate />
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
